import moment from 'moment';
import _ from 'lodash';
import sortData from '@shared/lib/general/sortData';
import initialState from './customerDetailInitialState';

const mutations = {
  CUSTOMER_DETAIL_CHANGE_VALUE: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    if (field === 'activeTab') {
      state.cycleViewTab = 'table';
    }
    state[field] = value;
  },
  CUSTOMER_DETAIL_CHANGE_HVAC_VALUE: (state, payload) => {
    const {
      idx,
      field,
      value,
    } = payload;

    const nHVACInfo = {
      ...state.newHVACInfo,
    };

    nHVACInfo[idx][field] = value;

    state.newHVACInfo = nHVACInfo;
  },

  CUSTOMER_DETAIL_FILTER_HVAC: (state, payload) => {
    const {
      filteredHvac,
      systemName,
    } = payload;

    state.selectedSystemName = systemName;
    state.filteredHvac = filteredHvac;
  },

  CUSTOMER_DETAIL_SET_CUSTOMER: (state, payload) => {
    const {
      customer,
      customerData,
      hubs,
      hvac,
      tZones,
      sensors,
      filters,
      systemNames,
      supplySensors,
      systemFilterOptions,
      providerPlan,
      propertyProfiles,
    } = payload;
    state.customer = customer;
    state.hubs = hubs;
    state.hvac = hvac;
    state.tZones = tZones;
    state.systemNames = systemNames;
    state.filteredHvac = _.cloneDeep(hvac);
    state.sensors = sensors;
    state.filters = filters;
    state.loading = false;
    state.supplySensors = supplySensors;
    state.systemFilterOptions = systemFilterOptions;
    state.customerData = customerData;
    state.providerPlan = providerPlan;
    state.propertyProfiles = propertyProfiles;
  },
  CUSTOMER_DETAIL_SET_FILTERED_DATA: (state, payload) => {
    const {
      tableData,
      alertsTableData,
      runtimeGraphData,
      systemFilter,
      cdTableOptions,
    } = payload;

    state.cycleTableData = tableData;
    state.deltaTTableData = tableData;
    state.runtimeGraphData = _.reverse(runtimeGraphData);
    state.alertsTabTableData = alertsTableData;
    state.systemFilterRef = { ...systemFilter };
    state.cdTableOptions = cdTableOptions;
    state.cycleLoading = false;
    state.loadingRuntimeGraph = false;
  },
  CUSTOMER_DETAIL_CLEAR_FILTERED_DATA: (state, payload) => {
    const {
      systemFilter,
      allAlerts,
      allCycles,
    } = payload;

    state.cycleTableData = allCycles;
    state.deltaTTableData = allCycles;
    state.alertsTabTableData = allAlerts;
    state.runtimeGraphData = state.initialRuntimeGraphData;
    state.systemFilter = systemFilter;
    state.systemFilterRef = { ...systemFilter };
  },
  CUSTOMER_DETAIL_SET_SORT: (state, payload) => {
    const {
      field,
      sort,
    } = payload;

    Object.keys(state.alertSort).forEach((s) => {
      if (s === field) {
        state.alertSort[s] = sort;
      } else {
        state.alertSort[s] = false;
      }
    });

    const filterActive = Object.values(state.alertFilter).reduce((acc, f) => {
      let active = acc;
      if (f && f !== 'all' && f.start) {
        active = true;
      }
      return active;
    }, false);

    let newTableData;

    if (filterActive) {
      newTableData = state.alertTableData.slice();
    } else {
      newTableData = state.allAlerts.slice();
    }

    if (sort) {
      newTableData = sortData(newTableData, field, sort);
    }

    state.alertTableData = newTableData;
  },
  CUSTOMER_DETAIL_SET_ALERT: (state, payload) => {
    const {
      alerts,
    } = payload;
    state.allAlerts = Object.freeze(alerts);
    state.alertTableData = alerts;
    state.alertLoading = false;
  },
  CUSTOMER_DETAIL_SET_SUBSCRIPTION: (state, payload) => {
    const {
      subscriptions,
    } = payload;

    state.subscription = subscriptions.filter((sub) => sub.status === 'Active');
  },
  CUSTOMER_DETAIL_SET_ACTIVITY: (state, payload) => {
    const {
      activity,
    } = payload;
    activity.forEach((a) => { if (!a.category) a.category = a.alertCategory; });
    state.activityTableData = activity;
    state.activityLoading = false;
  },
  CUSTOMER_DETAIL_SET_CYCLES: (state, payload) => {
    const {
      cycles,
    } = payload;
    if (cycles) {
      state.allCycles = Object.freeze(cycles);
    }
    state.cycleTableData = cycles;
    state.deltaTTableData = cycles;
    state.cycleLoading = false;
  },
  CUSTOMER_DETAIL_SET_CYCLE_DETAIL: (state, payload) => {
    const {
      cycle,
    } = payload;
    state.cycleDetail = cycle;
    state.showCycleDetailModal = true;
  },
  CUSTOMER_DETAIL_SET_EDIT: (state, payload) => {
    const {
      field,
    } = payload;
    const {
      customer,
    } = state;
    if (field === 'contact-info') {
      state.newCustomerInfo = {
        ...customer,
      };
      state.showInfoEdit = true;
      state.actionModalView = 'contact-info';
      state.showActionModal = true;
    } else if (field === 'billing') {
      state.newBillingAddress = {
        ...customer.billingAddress,
      };
      state.showBillingEdit = true;
    } else if (field === 'shipping') {
      state.newShippingAddress = {
        ...customer.shippingAddress,
      };
      state.showShippingEdit = true;
    } else if (field === 'edit-questionnaire') {
      state.showActionModal = true;
      state.actionModalView = field;
    }
  },
  CUSTOMER_DETAIL_EDIT_CUSTOMER: (state, payload) => {
    const {
      field,
      customer,
    } = payload;
    state[`${field}Editing`] = false;
    state[`show${field[0].toUpperCase() + field.slice(1)}Edit`] = false;
    state.customer = customer;
  },
  CUSTOMER_DETAIL_EDIT_CONTACT_INFO: (state, payload) => {
    const {
      customer,
    } = payload;

    state.infoEditing = false;
    state.showInfoEdit = false;
    if (state.newCustomerInfo.email !== state.customer.email) {
      state.actionModalView = 'welcome-email-again';
    } else {
      state.showActionModal = false;
    }
    state.customer = customer;
  },
  CUSTOMER_DETAIL_RESET_STATE: (state) => {
    Object.assign(state, initialState());
  },
  CUSTOMER_DETAIL_ERROR: (state, payload) => {
    const {
      errorObj,
    } = payload;
    state.errorObj = errorObj;
    state.infoEditing = false;
    state.billingEditing = false;
    state.shippingEditing = false;
  },
  CUSTOMER_DETAIL_SET_HVAC_EDIT: (state, payload) => {
    const {
      idx,
      edit,
    } = payload;
    const nHVACInfo = {
      ...state.filteredHvac[idx],
    };

    if (nHVACInfo.age) {
      const currentYear = moment().format('YYYY');
      const diff = Number(currentYear) - nHVACInfo.age;
      if (diff < 4) {
        nHVACInfo.age = 2;
      } else if (diff < 7) {
        nHVACInfo.age = 5;
      } else if (diff < 10) {
        nHVACInfo.age = 8;
      } else if (diff >= 10) {
        nHVACInfo.age = 11;
      }
    } else {
      nHVACInfo.age = '';
    }

    if (nHVACInfo.warranty) {
      const w = nHVACInfo.warranty.split('-');
      nHVACInfo.warranty = new Date(w[0], Number(w[1]) - 1, w[2]);
    }

    state.newHVACInfo[idx] = _.cloneDeep(nHVACInfo);
    state.filteredHvac[idx].edit = edit;
  },
  CUSTOMER_DETAIL_UPDATE_HVAC: (state, payload) => {
    const {
      idx,
      hvac,
    } = payload;

    const newHVAC = state.hvac.map((h, index) => {
      if (idx === index) {
        return hvac;
      }
      return h;
    });

    state.hvac = newHVAC;
  },
  CUSTOMER_DETAIL_SELECT_POINT: (state, payload) => {
    const {
      data,
    } = payload;

    const nSelectedData = state.selectedData.slice();

    const dataIdx = nSelectedData.reduce((acc, d, idx) => {
      let index = acc;
      if (d.startTime === data.startTime) {
        index = idx;
      }
      return index;
    }, -1);

    if (dataIdx !== -1) {
      nSelectedData.splice(dataIdx, 1);
    } else {
      if (nSelectedData.length >= 2) {
        nSelectedData.shift();
      }
      nSelectedData.push(data);
    }
    state.selectedData = nSelectedData;
    let start;
    let end;
    let uid;
    if (nSelectedData.length !== 0) {
      uid = nSelectedData[0].uid;
      if (nSelectedData.length === 1) {
        start = nSelectedData[0].startTime;
        end = nSelectedData[0].endTime;
      } else if (nSelectedData.length === 2) {
        if (nSelectedData[0].startTime < nSelectedData[1].startTime) {
          start = nSelectedData[0].startTime;
          end = nSelectedData[1].endTime;
        } else {
          start = nSelectedData[1].startTime;
          end = nSelectedData[0].endTime;
        }
      }
    }

    state.exportCSV = {
      range: {
        start,
        end,
      },
      uid,
    };
  },
  CUSTOMER_DETAIL_RESET_SELECT_POINT: (state) => {
    state.selectedData = [];
    // This is a hack to refresh the table
    state.csvGenerated += 1;
  },
  CUSTOMER_DETAIL_RUNTIME_GRAPH: (state, payload) => {
    const {
      graphData,
      systemFilter,
    } = payload;

    state.runtimeGraphData = _.reverse(graphData);
    state.initialRuntimeGraphData = _.reverse(graphData);
    state.loadingRuntimeGraph = false;
    state.systemFilter = systemFilter;
  },
  CUSTOMER_DETAIL_SET_ALERT_TAB: (state, payload) => {
    const {
      customerAllAlerts,
      tableData,
      alertTabCategories,
      alertShowType,
    } = payload;

    if (alertTabCategories) {
      state.alertTabCategories = alertTabCategories;
    }
    state.alertShowType = alertShowType;
    state.customerAllAlerts = customerAllAlerts;
    state.alertsTabTableData = tableData;
    state.loadingAlertsTab = false;
  },
  CUSTOMER_DETAIL_FILTER_ACTIVITY_TAB: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    let newTableData = [];

    if (field === 'category') {
      newTableData = newTableData.filter((a) => a.category === value);
    }

    state.alertTabFilter[field] = value;
    state.activityTableData = newTableData;
  },
  CUSTOMER_DETAIL_SET_EXPORT_RANGE: (state, payload) => {
    const {
      range,
      uid,
      start,
      end,
    } = payload;

    const nExportCSV = _.cloneDeep(state.exportCSV);
    if (range && (range.start || range.end)) {
      nExportCSV.range = _.clone(range);
    }
    if (start) {
      nExportCSV.range.start = start;
    }
    if (end) {
      nExportCSV.range.end = end;
    }
    if (uid) {
      nExportCSV.uid = uid;
    }
    state.exportCSV = nExportCSV;
  },
  CUSTOMER_DETAIL_GENERATED_CSV: (state) => {
    state.generatingCSV = false;
    state.selectedData = [];
    // This is a hack to refresh the table
    state.csvGenerated += 1;
  },
  CUSTOMER_DETAIL_RESET_EXPORT_RANGE: (state) => {
    state.exportCSV = _.cloneDeep(initialState().exportCSV);
  },
  CUSTOMER_DETAIL_RESET_ALERT_TAB: (state) => {
    state.alertsTabTableData = [];
    state.loadingAlertsTab = true;
  },
  CUSTOMER_DETAIL_CHANGE_CD_OPTIONS: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state.cdTableOptions[field] = value;
  },
  CUSTOMER_DETAIL_CHANGE_CO_OPTIONS: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state.coTableOptions[field] = value;
  },
  CUSTOMER_DETAIL_CHANGE_VALUES: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
  CUSTOMER_DETAIL_SELECTED_IMAGE: (state, payload) => {
    const {
      image,
    } = payload;

    const {
      uploadImageType,
      currentHvac,
    } = state;

    const imageType = uploadImageType || 'nameplate';
    const formData = new FormData();
    formData.append('fileName', imageType);
    formData.append('uId', currentHvac.uId);
    formData.append('photo', image);
    state.imageFormData = formData;
  },
  CUSTOMER_DETAIL_UPLOAD_IMAGE: (state, payload) => {
    const {
      response,
    } = payload;

    const {
      filteredHvac,
      uploadImageType,
    } = state;

    state.filteredHvac = filteredHvac.map((h) => {
      if (h.uid === response.uid) {
        if (uploadImageType === 'furnace') {
          h.furnaceImageUrl = response.imageUrl;
        } else {
          h.imageUrl = response.imageUrl;
        }
      }
      return h;
    });

    state.showActionModal = false;
    state.uploadingImage = false;
  },
  CUSTOMER_DETAIL_CANCEL_SUBSCRIPTION: (state) => {
    state.showActionModal = false;
    state.cancellingSubscription = false;
  },
  CUSTOMER_DETAIL_SET_CHRONIC_ALERTS: (state, payload) => {
    const {
      chronicAlerts,
    } = payload;
    state.chronicAlerts = chronicAlerts;
  },
  ADMIN_LOGOUT: (state) => {
    Object.assign(state, initialState());
  },
  CUSTOMER_DETAIL_UPDATE_CHRONIC: (state, payload) => {
    const {
      uid,
      alertType,
    } = payload;
    const { chronicAlerts } = state;
    state.chronicAlerts = chronicAlerts.filter((c) => !(c.alertType.includes(alertType)
      && c.uid.includes(uid)));
  },
  CUSTOMER_DETAIL_RESET_MODAL: (state) => {
    state.actionModalView = '';
    state.showActionModal = false;
    state.memberAddress = {};
  },
};

export default mutations;
